<div class="chat-circle-chat hidemobileview" *ngIf="chathide == true">
  <section class="msger" style="float: inline-end;padding: 0;">
    <header class="msger-header">
      <div class="msger-header-title">
        <i class="fas fa-comment-alt"></i> Customer Support
      </div>
      <div class="msger-header-options" (click)=" closechat() ">
        <span><i class="fa fa-times" aria-hidden="true"></i></span>
      </div>
    </header>

    <main class="msger-chat">
      <div class="msg left-msg">

        <div class="msg-bubble answer-bubble">
          <div class="msg-info">
            <div class="msg-info-name">Customer Care</div>
            <div class="msg-info-time">12:45</div>
          </div>

          <div class="msg-text">
            Hi, welcome to Nexmir! Go ahead and send me a message.😄
          </div>
        </div>


      </div>


      <div class="row" *ngIf="custIdHide == 0 && loginIdpage == 0">
        <div class="col-lg-8 m-auto">
          <!-- CUSTOMER CHECKING -->
          <div class="theme-card" *ngIf="logphshow">
            <form class="theme-form" [formGroup]="Login">
              <div class="form-group">
                <label for="PhoneNumber">Phone <span class="text-danger">*</span> </label>
                <input type="tel" id="phoneNo" name="phoneNo" class="form-control" formControlName="phoneNo"
                  placeholder="Enter your PhoneNumber" autocomplete="off" maxlength="10" autofocus="autofocus"
                  [(ngModel)]="phoneNo" (keypress)="validateNumericInput($event)" (keyup.enter)="log.focus()" required>
                <div *ngIf="Login.get('phoneNo').errors?.pattern && (Login.get('phoneNo').touched || submitted)"
                  class="text text-danger">
                  Please enter a valid 10-digit phone number
                </div>
              </div>

              <button type="submit" id="next" aria-label="next" class="btn btn-solid m-2 btn-sm" #log
                [disabled]="Login.get('phoneNo').invalid || phoneNo.length !== 10" (click)="getloginData()">
                Next
              </button>

            </form>
          </div>


          <!-- ADD NEW CUSTOMER LOGIN  -->

          <div class="theme-card" *ngIf="loginshow">
            <form class="theme-form">

              <div class="form-group">
                <label for="name">Name <span class="text-danger">*</span> </label>

                <input type="text" class="form-control" [formControl]="Login.controls['name']" id="name" maxlength="25"
                  placeholder="Enter your Name" [(ngModel)]="login.name" value="" autocomplete="off"
                  (keypress)="validateAlphabeticInput($event)">

                <div *ngIf="Login.controls.name.touched && Login.controls.name.errors?.required"
                  class="text text-danger m-3">
                  Name must be at least 20 characters long*
                </div>
              </div>

              <div class="form-group">
                <label for="PhoneNumber">Phone <span class="text-danger">*</span></label>

                <!-- <input type="text" class="form-control" disabled placeholder="Enter your PhoneNumber"
                                maxlength="10" [formControl]="Login.controls['phoneno']" [(ngModel)]="login.phoneno"
                                autocomplete="off" [disabled]="isDisabled"> -->

                <input type="text" class="form-control" disabled placeholder="Enter your PhoneNumber" maxlength="10"
                  value="{{login.phoneno}}" autocomplete="off" [disabled]="isDisabled">

                <!-- <div *ngIf="Login.controls.phoneno.touched && Login.controls.phoneno.errors?.required"
                                class="text text-danger m-3">
                                Phone No must be at least 10 characters long*
                            </div> -->

              </div>


              <div class="form-group">
                <label for="email">Email (optional)</label>

                <input type="text" name="email" class="form-control" id="email" maxlength="50"
                  placeholder="Enter your Email" (input)="onInput($event)" [(ngModel)]="login.email" value=""
                  autocomplete="off">

                <div *ngIf="login.email && (login.email.indexOf('&#64;') === -1 || login.email.indexOf('.') === -1)"
                  class="text text-danger">
                  Email must contain '&#64;' and '.'
                </div>

                <!-- 
                            <div *ngIf="emailInputTouched && login.email?.length < 40" class="text text-danger">
                                Email must be at least 25 characters long*
                            </div> -->
              </div>

              <button class="btn btn-solid m-2" id="back-btn" aria-label="back Data" (click)="logback()">Back</button>

              <button class="btn btn-solid" id="login-btn" aria-label="login Data" [disabled]="!Login.valid"
                (click)="SaveNewCustomer()">Login</button>
            </form>
          </div>


          <!-- VERIFICATION CODE   -->

          <div class="theme-card" *ngIf="otpshow">
            <!-- <div class="theme-card"> -->
            <form class="theme-form">
              <label for="number" style="text-align: center;">ENTER VERIFICATION CODE
              </label>

              <p class="text-[15px] text-slate-500">
                Enter the 4-digit verification code that was sent to your {{ mobile }} .
                <a class="font-medium text-indigo-500 hover:text-indigo-600" style="cursor: pointer;"
                  (click)="loginphone()">
                  Change PhoneNumber
                </a>
              </p>

              <div class="theme-form row" style="margin: 0;">

                <input type="tel" #secretNumber1 id="secretNumber1" name="secretNumber1" size="25"
                  style="text-align:center" class="form-control m-2" maxlength="1" autocomplete="off"
                  [(ngModel)]="enterotp" (keyup)="otpMove($event, '',secretNumber1, secretNumber2, secretNumber3)"
                  autofocus="autofocus" />

                <input type="tel" #secretNumber2 id="secretNumber2" name="secretNumber2" size="25"
                  style="text-align:center" class="form-control m-2" maxlength="1" autocomplete="off"
                  [(ngModel)]="enterotp1"
                  (keyup)="otpMove($event, secretNumber1, secretNumber2, secretNumber3, secretNumber4)" />

                <input type="tel" #secretNumber3 id="secretNumber3" name="secretNumber3" size="25"
                  style="text-align:center" class="form-control m-2" maxlength="1" autocomplete="off"
                  [(ngModel)]="enterotp2"
                  (keyup)="otpMove($event, secretNumber2, secretNumber3, secretNumber4,secretNumber1)" />

                <input type="tel" #secretNumber4 id="secretNumber4" name="secretNumber4" size="25"
                  style="text-align:center" class="form-control m-2" maxlength="1" autocomplete="off"
                  [(ngModel)]="enterotp3" (keyup)="otpMove($event,  secretNumber3, secretNumber4, secretNumber1,'')"
                  (keyup.enter)="verify.focus()" />

              </div>

              <button class="btn btn-solid m-2 btn-sm" id="verify-btn" aria-label="verify Data" #verify
                (click)="GetNewcusOtp()">Verify</button>
            </form>
            <div class="text-sm text-slate-500 mt-4">
              Didn't receive code? <a class="font-medium text-indigo-500 hover:text-indigo-600;"
                style="cursor: pointer;" (click)="GetOldCustomerLogin()">Resend</a>
            </div>
            <span style="margin-top:10px; color: red;">{{otpmsg}}</span>
          </div>

        </div>

        <!-- <div class="col-lg-6 right-login">
                <h3>New Customer</h3>
                <div class="theme-card authentication-right">
                    <h6 class="title-font">Create A Account</h6>
                    <p>Sign up for a free account at our store. Registration is quick and easy. It allows you to be able
                        to order from our shop. To start shopping click register.</p>
                    <button class="btn btn-solid">Create an Account</button>
                </div>
            </div> -->

      </div>




      <!-- chatttttttttttt--------dataaaaaaaaaaaaaaaaaaaaa -->
      <input type="hidden" [(ngModel)]="selectedQuestionId" />

      <!-- Show Questions -->
      <!-- Initial Questions (stay on top) -->
      <ng-container *ngIf="custIdHide > 0">
        <div class="question-wrapper"
          style="display: flex; flex-wrap: wrap; gap: 10px; justify-content: flex-start; margin-bottom: 20px;">
          <div *ngFor="let data of details" class="msg-row">
            <div class="msg left-msg" (click)="getAnswersForQuestion(data.id)">
              <div class="msg-bubble question-bubble">
                <div class="msg-text">{{ data.name }} </div>
              </div>
            </div>
          </div>

          <!-- Others.. initial button -->
          <div class="msg-row" *ngIf="chathisId == 0">
            <div class="msg right-msg">
              <div class="msg-bubble question-bubble" (click)="Next5Ques(details)">
                <div class="msg-text">Others..</div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- Dynamically added: Questions & Answers -->
      <div *ngFor="let item of chatQA" class="qa-block" style="margin-top: 15px;">
        <!-- Question Row -->
        <div class="msg-row" style="justify-content: flex-end;">
          <div class="msg right-msg">
            <div class="msg-bubble question-bubble">
              <div class="msg-text">{{ item.question.name || item.question.Name }}</div>
              <small class="msg-time">{{ item.time }}</small>
            </div>
          </div>
        </div>

        <!-- Answer(s) -->
        <div class="msg-row">
          <div class="msg left-msg" *ngFor="let ans of item.answers">
            <a *ngIf="ans.id || ans.Id"
              [routerLink]="['/shop/product/details', ans.id || ans.Id, (ans.name || ans.Name).split(' ').join('-')]"
              class="msg-bubble" style="text-decoration: none;">
              <div class="msg-text  answer-bubble">{{ ans.name || ans.Name }}</div>
            </a>
            <div *ngIf="!(ans.id || ans.Id)" class="msg-bubble answer-bubble">
              <div class="msg-text">{{ ans.name || ans.Name }}</div>
            </div>
          </div>
        </div>

        <!-- New Next5 Ques if it's an Others click -->
        <div *ngIf="item.question.name === 'Others'" class="msg-row" style="flex-wrap: wrap; gap: 10px;">
          <div *ngFor="let ques of item.next5" class="msg left-msg" (click)="getAnswersForQuestion(ques.id)">
            <div class="msg-bubble question-bubble">
              <div class="msg-text">{{ ques.name || ques.Name }}</div>
            </div>
          </div>

          <div class="msg right-msg" *ngIf="item.next5.length > 0">
            <div class="msg-bubble question-bubble" (click)="Next5Ques(item.next5)">
              <div class="msg-text">Others..</div>
            </div>
          </div>
        </div>
      </div>












    </main>
    <!-- <form class="msger-inputarea">
      <input type="text" class="msger-input" placeholder="Enter your message...">
      <button type="submit" class="msger-send-btn" id="send-btn" aria-label="send Data" (click)="send()">Send</button>
    </form> -->
  </section>
</div>





<div class="btn btn-raised chat-circle hidemobileview" style=" z-index: 1000;" (click)="openchat(0)"
  *ngIf="chathide == false">
  <div class="chat-overlay"></div>
  <i style=" font-size: 25px; color: white;" class="fa fa-commenting-o" aria-hidden="true"></i>
</div>



<div class="chat1-circle-chat1 mobilehide" *ngIf="IdChat == 1">
  <section class="msger1" style="float: inline-end;padding: 0;">
    <header class="msger-header">
      <div class="msger-header-title">
        <i class="fas fa-comment-alt"></i> Customer Support
      </div>
      <div class="msger-header-options" (click)=" closechat() ">
        <span><i class="fa fa-times" aria-hidden="true"></i></span>
      </div>
    </header>



    <main class="msger-chat">
      <div class="msg left-msg">

        <div class="msg-bubble answer-bubble">
          <div class="msg-info">
            <div class="msg-info-name">Customer Care</div>
            <div class="msg-info-time">12:45</div>
          </div>

          <div class="msg-text">
            Hi, welcome to Nexmir! Go ahead and send me a message.{{custIdHide}} {{loginIdpage}} 😄
          </div>
        </div>


      </div>


      <div class="row" *ngIf="custIdHide == 0 && loginIdpage == 0">
        <div class="col-lg-8 m-auto">
          <!-- CUSTOMER CHECKING -->
          <div class="theme-card" *ngIf="logphshow">
            <form class="theme-form" [formGroup]="Login">
              <div class="form-group">
                <label for="PhoneNumber">Phone <span class="text-danger">*</span> </label>
                <input type="tel" id="phoneNo" name="phoneNo" class="form-control" formControlName="phoneNo"
                  placeholder="Enter your PhoneNumber" autocomplete="off" maxlength="10" autofocus="autofocus"
                  [(ngModel)]="phoneNo" (keypress)="validateNumericInput($event)" (keyup.enter)="log.focus()" required>
                <div *ngIf="Login.get('phoneNo').errors?.pattern && (Login.get('phoneNo').touched || submitted)"
                  class="text text-danger">
                  Please enter a valid 10-digit phone number
                </div>
              </div>

              <button type="submit" id="next" aria-label="next" class="btn btn-solid m-2 btn-sm" #log
                [disabled]="Login.get('phoneNo').invalid || phoneNo.length !== 10" (click)="getloginData()">
                Next
              </button>

            </form>
          </div>


          <!-- ADD NEW CUSTOMER LOGIN  -->

          <div class="theme-card" *ngIf="loginshow">
            <form class="theme-form">

              <div class="form-group">
                <label for="name">Name <span class="text-danger">*</span> </label>

                <input type="text" class="form-control" [formControl]="Login.controls['name']" id="name" maxlength="25"
                  placeholder="Enter your Name" [(ngModel)]="login.name" value="" autocomplete="off"
                  (keypress)="validateAlphabeticInput($event)">

                <div *ngIf="Login.controls.name.touched && Login.controls.name.errors?.required"
                  class="text text-danger m-3">
                  Name must be at least 20 characters long*
                </div>
              </div>

              <div class="form-group">
                <label for="PhoneNumber">Phone <span class="text-danger">*</span></label>

                <!-- <input type="text" class="form-control" disabled placeholder="Enter your PhoneNumber"
                                maxlength="10" [formControl]="Login.controls['phoneno']" [(ngModel)]="login.phoneno"
                                autocomplete="off" [disabled]="isDisabled"> -->

                <input type="text" class="form-control" disabled placeholder="Enter your PhoneNumber" maxlength="10"
                  value="{{login.phoneno}}" autocomplete="off" [disabled]="isDisabled">

                <!-- <div *ngIf="Login.controls.phoneno.touched && Login.controls.phoneno.errors?.required"
                                class="text text-danger m-3">
                                Phone No must be at least 10 characters long*
                            </div> -->

              </div>


              <div class="form-group">
                <label for="email">Email (optional)</label>

                <input type="text" name="email" class="form-control" id="email" maxlength="50"
                  placeholder="Enter your Email" (input)="onInput($event)" [(ngModel)]="login.email" value=""
                  autocomplete="off">

                <div *ngIf="login.email && (login.email.indexOf('&#64;') === -1 || login.email.indexOf('.') === -1)"
                  class="text text-danger">
                  Email must contain '&#64;' and '.'
                </div>

                <!-- 
                            <div *ngIf="emailInputTouched && login.email?.length < 40" class="text text-danger">
                                Email must be at least 25 characters long*
                            </div> -->
              </div>

              <button class="btn btn-solid m-2" id="back-btn" aria-label="back Data" (click)="logback()">Back</button>

              <button class="btn btn-solid" id="login-btn" aria-label="login Data" [disabled]="!Login.valid"
                (click)="SaveNewCustomer()">Login</button>
            </form>
          </div>


          <!-- VERIFICATION CODE   -->

          <div class="theme-card" *ngIf="otpshow">
            <!-- <div class="theme-card"> -->
            <form class="theme-form">
              <label for="number" style="text-align: center;">ENTER VERIFICATION CODE
              </label>

              <p class="text-[15px] text-slate-500">
                Enter the 4-digit verification code that was sent to your {{ mobile }} .
                <a class="font-medium text-indigo-500 hover:text-indigo-600" style="cursor: pointer;"
                  (click)="loginphone()">
                  Change PhoneNumber
                </a>
              </p>

              <div class="theme-form row" style="margin: 0;">

                <input type="tel" #secretNumber1 id="secretNumber1" name="secretNumber1" size="25"
                  style="text-align:center" class="form-control m-2" maxlength="1" autocomplete="off"
                  [(ngModel)]="enterotp" (keyup)="otpMove($event, '',secretNumber1, secretNumber2, secretNumber3)"
                  autofocus="autofocus" />

                <input type="tel" #secretNumber2 id="secretNumber2" name="secretNumber2" size="25"
                  style="text-align:center" class="form-control m-2" maxlength="1" autocomplete="off"
                  [(ngModel)]="enterotp1"
                  (keyup)="otpMove($event, secretNumber1, secretNumber2, secretNumber3, secretNumber4)" />

                <input type="tel" #secretNumber3 id="secretNumber3" name="secretNumber3" size="25"
                  style="text-align:center" class="form-control m-2" maxlength="1" autocomplete="off"
                  [(ngModel)]="enterotp2"
                  (keyup)="otpMove($event, secretNumber2, secretNumber3, secretNumber4,secretNumber1)" />

                <input type="tel" #secretNumber4 id="secretNumber4" name="secretNumber4" size="25"
                  style="text-align:center" class="form-control m-2" maxlength="1" autocomplete="off"
                  [(ngModel)]="enterotp3" (keyup)="otpMove($event,  secretNumber3, secretNumber4, secretNumber1,'')"
                  (keyup.enter)="verify.focus()" />

              </div>

              <button class="btn btn-solid m-2 btn-sm" id="verify-btn" aria-label="verify Data" #verify
                (click)="GetNewcusOtp()">Verify</button>
            </form>
            <div class="text-sm text-slate-500 mt-4">
              Didn't receive code? <a class="font-medium text-indigo-500 hover:text-indigo-600;"
                style="cursor: pointer;" (click)="GetOldCustomerLogin()">Resend</a>
            </div>
            <span style="margin-top:10px; color: red;">{{otpmsg}}</span>
          </div>

        </div>

        <!-- <div class="col-lg-6 right-login">
                <h3>New Customer</h3>
                <div class="theme-card authentication-right">
                    <h6 class="title-font">Create A Account</h6>
                    <p>Sign up for a free account at our store. Registration is quick and easy. It allows you to be able
                        to order from our shop. To start shopping click register.</p>
                    <button class="btn btn-solid">Create an Account</button>
                </div>
            </div> -->

      </div>




      <!-- chatttttttttttt--------dataaaaaaaaaaaaaaaaaaaaa -->
      <input type="hidden" [(ngModel)]="selectedQuestionId" />

      <!-- Show Questions -->
      <!-- Initial Questions (stay on top) -->
      <ng-container *ngIf="custIdHide > 0">
        <div class="question-wrapper"
          style="display: flex; flex-wrap: wrap; gap: 10px; justify-content: flex-start; margin-bottom: 20px;">
          <div *ngFor="let data of details" class="msg-row">
            <div class="msg left-msg" (click)="getAnswersForQuestion(data.id)">
              <div class="msg-bubble question-bubble">
                <div class="msg-text">{{ data.name }} </div>
              </div>
            </div>
          </div>

          <!-- Others.. initial button -->
          <div class="msg-row" *ngIf="chathisId == 0">
            <div class="msg right-msg">
              <div class="msg-bubble question-bubble" (click)="Next5Ques(details)">
                <div class="msg-text">Others..</div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- Dynamically added: Questions & Answers -->
      <div *ngFor="let item of chatQA" class="qa-block" style="margin-top: 15px;">
        <!-- Question Row -->
        <div class="msg-row" style="justify-content: flex-end;">
          <div class="msg right-msg">
            <div class="msg-bubble question-bubble">
              <div class="msg-text">{{ item.question.name || item.question.Name }}</div>
              <small class="msg-time">{{ item.time }}</small>
            </div>
          </div>
        </div>

        <!-- Answer(s) -->
        <div class="msg-row">
          <div class="msg left-msg" *ngFor="let ans of item.answers">
            <a *ngIf="ans.id || ans.Id"
              [routerLink]="['/shop/product/details', ans.id || ans.Id, (ans.name || ans.Name).split(' ').join('-')]"
              class="msg-bubble" style="text-decoration: none;">
              <div class="msg-text  answer-bubble">{{ ans.name || ans.Name }}</div>
            </a>
            <div *ngIf="!(ans.id || ans.Id)" class="msg-bubble answer-bubble">
              <div class="msg-text">{{ ans.name || ans.Name }}</div>
            </div>
          </div>
        </div>

        <!-- New Next5 Ques if it's an Others click -->
        <div *ngIf="item.question.name === 'Others'" class="msg-row" style="flex-wrap: wrap; gap: 10px;">
          <div *ngFor="let ques of item.next5" class="msg left-msg" (click)="getAnswersForQuestion(ques.id)">
            <div class="msg-bubble question-bubble">
              <div class="msg-text">{{ ques.name || ques.Name }}</div>
            </div>
          </div>

          <div class="msg right-msg" *ngIf="item.next5.length > 0">
            <div class="msg-bubble question-bubble" (click)="Next5Ques(item.next5)">
              <div class="msg-text">Others..</div>
            </div>
          </div>
        </div>
      </div>












    </main>

    <form class="msger-inputarea" (ngSubmit)="send()">
      <input type="text" class="msger-input" placeholder="Enter your message..." required>
      <button type="submit" class="msger-send-btn" aria-label="send Data">Send</button>
    </form>

  </section>
</div>